const state = {
    timesheet: [],
    timesheetId:[],
    timesheetStatus:[],
    loading: false
};

export default state;